import RemiseFinAnneeGenerationController from './remise.fin.annee.generation.controller';

export default {
    template: require('./remise.fin.annee.generation.html'),
    controller: RemiseFinAnneeGenerationController
};
